<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="returnDialog.visible"
      :title="$t('SeaExport.BatchPrint')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" label-position="left">
        <el-form-item :label="$t('SeaExport.Customer')">
          <el-input v-model="returnDialog.formData.companyCName" no="1" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Receiver2')">
          <el-input v-model="returnDialog.formData.receiver" no="2" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContactNumber')">
          <el-input v-model="returnDialog.formData.tel" no="3" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ExpressAddress')">
          <el-input
            v-model="returnDialog.formData.address"
            no="4"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReturnExpressNumber')">
          <el-input v-model="returnDialog.formData.expressNo" no="5" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReturnDate')">
          <el-date-picker
            v-model="returnDialog.formData.returnDate"
            no="6"
            :editable="false"
            :clearable="false"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="7" type="primary" @click="returnPrintHandler(true)">{{ $t('SeaExport.print') }}</el-button>
        <el-button no="8" type="primary" @click="returnPrintHandler(false)">{{ $t('SeaExport.Chargeback') }}</el-button>
        <el-button no="9" @click="returnCancle">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { cache } from '@/utils/cacheManager'
import { File } from '@/class/model/booking/File'
import { batchReturnFileHandler } from '@/api/seaExport/file'

export default {
  name: 'DcReturnWindow',
  components: { CargoAdvanceSelect, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    returnDialog: { type: Object, required: true },
    selectedFiles: { type: Array, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {}
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    returnCancle() {
      this.$confirm(this.$t('Message.SureYouWantToCancel'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => { this.returnDialog.visible = false })
    },
    returnPrintHandler(isPrint) {
      if (!this.returnValidate()) return
      const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.returnDialog.formData.customerId)
      if (customer && customer.address !== this.returnDialog.formData.address) {
        this.$confirm(this.$t('CargoMsg.Cargo_MANMWCSAISCTD'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => { this.returnDoPrint(isPrint) })
      } else {
        this.returnDoPrint(isPrint)
      }
    },
    returnDoPrint(isPrint) {
      if (isPrint) {
        let msg = this.$t('CargoMsg.Cargo_SureToPrint')
        const map = {}

        for (const file of this.selectedFiles) {
          map[file.state] = true
        }
        if (map.hasOwnProperty(2) && map.hasOwnProperty(3)) {
          msg += this.$t('SeaExport.ClickYesRetrievedToReturnedStatus')
        } else if (map.hasOwnProperty(2)) {
          msg += this.$t('SeaExport.ClickYesToReturnedStatus')
        }
        this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.returnUpdateFiles(isPrint)
        })
      } else {
        this.returnUpdateFiles(isPrint)
      }
    },
    async returnUpdateFiles(isPrint) {
      const fileList = []
      for (const file of this.selectedFiles) {
        file.receiveCompany = this.returnDialog.formData.companyCName
        file.receivePerson = this.returnDialog.formData.receiver
        file.receiveTel = this.returnDialog.formData.tel
        file.expressAddress = this.returnDialog.formData.address
        file.returnExpressNo = this.returnDialog.formData.expressNo
        file.state = 3// 已退还
        file.returnDate = this.returnDialog.formData.returnDate
        file.returnPerson = this.$store.getters.userId
        fileList.push(file)
      }
      batchReturnFileHandler(fileList).then(res => {
        if (isPrint) {
          const f = this.selectedFiles[0]
          const params = { 'FILE_UUID': f.uuid, 'USER_ID': this.$store.getters.userId }
          this.templateSelectorDialog.category = 'FILERETURN'
          this.templateSelectorDialog.cxt = new File(f)
          this.templateSelectorDialog.data = params
          this.templateSelectorDialog.visible = true
        }
        this.returnDialog.visible = false
        this.$emit('successHandler', fileList)
      })
    },
    returnValidate() {
      if (this.returnDialog.formData.companyCName === '') {
        this.$message.warning(this.$t('SeaExport.InputCustomerName'))
        return false
      }
      if (this.returnDialog.formData.receiver === '') {
        this.$message.warning(this.$t('SeaExport.InputRecipientName'))
        return false
      }
      if (this.returnDialog.formData.tel === '') {
        this.$message.warning(this.$t('SeaExport.InputContactNumberMark'))
        return false
      }
      if (this.returnDialog.formData.address === '') {
        this.$message.warning(this.$t('SeaExport.InputExpressAddress'))
        return false
      }
      if (this.returnDialog.formData.expressNo === '') {
        this.$message.warning(this.$t('SeaExport.InputReturnExpressNumber'))
        return false
      }
      if (!this.isLessThanBackDate()) {
        this.$message.warning(this.$t('SeaExport.ReturnDateGreaterThanRetrieveDate'))
        return false
      }
      return true
    },
    isLessThanBackDate() {
      for (const file of this.selectedFiles) {
        if (file.backDate && file.backDate > this.returnDialog.formData.returnDate) {
          return false
        }
      }
      return true
    },
    getCreditFileSetting() {
      const setting = cache.config.get('creditBlockFile')
      var d = {}
      var a = []
      a = setting.split(',')
      for (const o of a) {
        d[o.split('-')[0]] = o.split('-')[1]
      }

      return d
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

